import { apiUrl } from '@/constants';
import axios from 'axios';

const state = {
  orders: [],
};

const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders;
  }
  
};

const actions = {
  async createOrder({commit}, order) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${apiUrl}/orders`, order, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SET_ORDERS', response.data);
    } catch (error) {
      console.error('Error creating order:', error);
    }
  },
  async editOrder({commit}, order){
    try {
      const token = localStorage.getItem('token');
      const response = await axios.patch(`${apiUrl}/orders/${order.id}`, order ,{
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SET_ORDERS', response.data);

    }catch(error){
      console.error('Error editing order:', error);
    }

  },
  async fetchOrders({commit}){
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${apiUrl}/orders` ,{
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      commit('SET_ORDERS', response.data);
    } catch (error) {
      console.error('Error fetching order:', error);
    }

  },
  
};

const getters = {
  getOrders: (state) => state.orders,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
